
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3SDbS", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.3901dfb0.js.map
